// MOKU Recommend
/* ==========================================
   Preorder
========================================== */

function formatPreorderCode(code) {
  if (!code) return '';

  const year = code.substring(0, 4);
  const month = parseInt(code.substring(4, 6), 10);
  const term = code.substring(6);

  const termMap = {
    E: '上旬',
    M: '中旬',
    L: '末'
  };

  return `${year}年${month}月${termMap[term]}発送予定`;
}

window.formatPreorderCode = formatPreorderCode;

function updatePreorderDisplay(scope = document) {

  const variantInput = scope.querySelector('input[name="id"]');
  if (!variantInput) return;

  const variantId = variantInput.value;

  const wrapper = scope.querySelector('[id^="preorder-message-"]');
  if (!wrapper) return;

  const productId = wrapper.id.replace('preorder-message-', '');

  const display = scope.querySelector(`#preorder-display-${productId}`);
  if (!display) return;

  const variantData =
    window.preorderVariantData?.[productId]?.[variantId];

  const preorderCodeInput =
    scope.querySelector('#preorder-code-property');

  const preorderDisplayInput =
    scope.querySelector('#preorder-display-property');

  if (variantData?.preorder_code) {

    const preorderDisplay =
      formatPreorderCode(variantData.preorder_code);

    wrapper.hidden = false;
    display.textContent = preorderDisplay;

    if (preorderCodeInput) {
      preorderCodeInput.value = variantData.preorder_code;
      preorderCodeInput.disabled = false;
    }

    if (preorderDisplayInput) {
      preorderDisplayInput.value = preorderDisplay;
      preorderDisplayInput.disabled = false;
    }

  } else {

    wrapper.hidden = true;
    display.textContent = "";

    if (preorderCodeInput) {
      preorderCodeInput.value = "";
      preorderCodeInput.disabled = true;
    }

    if (preorderDisplayInput) {
      preorderDisplayInput.value = "";
      preorderDisplayInput.disabled = true;
    }

  }

}

window.updatePreorderDisplay = updatePreorderDisplay;

/* 初期表示 */
document.addEventListener("DOMContentLoaded", () => {
  updatePreorderDisplay();
});

/* バリアント切り替え */
document.addEventListener("variant:change", (e) => {

  const productId = e.detail?.product?.id;

  if (!productId) return;

  const wrapper =
    document.getElementById(`preorder-message-${productId}`);

  if (!wrapper) return;

  updatePreorderDisplay(wrapper.closest("form") || document);

});